import React from 'react';
import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FormattedMessages from '../../../messages/RootComponentsFormattedMessages';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const FileUpload = ({
  name,
  label = '',
  onChange,
  value,
  error = '',
  helperText = '',
  multiple = false,
  disabled = false,
}) => {
  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      color="secondary"
      tabIndex={-1}
      startIcon={<CloudUploadIcon />}
      disabled={disabled}
    >
      <Typography sx={{ whiteSpace: 'nowrap' }}>
        {label || FormattedMessages.uploadFiles}
      </Typography>
      <VisuallyHiddenInput
        type="file"
        name={name}
        onChange={onChange}
        multiple={multiple}
        error={error}
        helperText={helperText || error}
      />
    </Button>
  );
};

export default FileUpload;
